import {useVentrataClient} from 'hooks/useVentrataClient'
import {useCallback} from 'react'
import {Params, Ventrata} from 'types'

export const useAddBookingApiMethod = () => {
  const ventrata = useVentrataClient()

  return useCallback(
    async ({orderId, bookingUuid, productId, optionId, availabilityId, unitItems}: Params.AddBooking) => {
      const {data} = await ventrata.post<Ventrata.Booking>(
        `/bookings`,
        {
          orderId,
          uuid: bookingUuid,
          productId,
          optionId,
          unitItems,
          availabilityId,
        },
        {
          headers: {
            'Octo-Capabilities': 'octo/cart',
          },
        }
      )

      return data
    },
    [ventrata]
  )
}
